import { render, staticRenderFns } from "./SalesChannel.vue?vue&type=template&id=28c2dc6e"
import script from "./SalesChannel.vue?vue&type=script&lang=js"
export * from "./SalesChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports